export function normalizeLinkUrl(input: string): string | null {
  const value = input.trim();
  if (!value) {
    return null;
  }

  const candidate = /^https?:\/\//i.test(value) ? value : `https://${value}`;

  try {
    return new URL(candidate).href;
  } catch {
    return null;
  }
}
